class BaseAdapter {
  constructor(locator) {
    this.locator = locator
    this.ready = false
  }

  init() {
    console.warn(this.constructor.name, 'init not implemented')

    return Promise.resolve()
  }

  trackEvent(eventName, payload) {
    console.warn(
      this.constructor.name,
      'trackEvent not implemented',
      eventName,
      payload
    )
  }

  identify(userId, traits = {}) {
    console.warn(
      this.constructor.name,
      'identify not implemented',
      userId,
      traits
    )
  }

  reset() {
    console.warn(this.constructor.name, 'reset not implemented')
  }
}

export default BaseAdapter
